module.exports={cookies:"Cookies",help:"Ajuda",privacy:"Privacidade (ATUALIZADO)",signInWithId:"Fazer logon com uma Adobe ID",termsOfUse:"Termos de uso"};